import React, { useState, useEffect } from "react";

interface MonthYearPickerProps {
  value: Date | null;
  onChange: (value: Date) => void;
}

const MonthYearPicker: React.FC<MonthYearPickerProps> = ({
  value,
  onChange,
}) => {
  const [selectedMonth, setSelectedMonth] = useState<string>("");
  const [selectedYear, setSelectedYear] = useState<string>("");

  useEffect(() => {
    if (value) {
      const date = new Date(value);
      const year = date.getFullYear().toString();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      setSelectedYear(year);
      setSelectedMonth(month);
    }
  }, [value]);

  const handleMonthChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newMonth = e.target.value;
    setSelectedMonth(newMonth);
    if (selectedYear) {
      onChange(
        new Date(parseInt(selectedYear, 10), parseInt(newMonth, 10) - 1, 1),
      );
    }
  };

  const handleYearChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newYear = e.target.value;
    setSelectedYear(newYear);
    if (selectedMonth) {
      onChange(
        new Date(parseInt(newYear, 10), parseInt(selectedMonth, 10) - 1, 1),
      );
    }
  };

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 100 }, (_, i) => currentYear - i);
  const months = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  return (
    <div style={{ display: "flex", gap: "5px" }}>
      <select
        value={selectedMonth}
        onChange={handleMonthChange}
        className="form-select"
        style={{ width: "60%" }}
      >
        <option value="" disabled>
          Month
        </option>
        {months.map((month) => (
          <option key={month.value} value={month.value}>
            {month.label}
          </option>
        ))}
      </select>

      <select
        value={selectedYear}
        onChange={handleYearChange}
        className="form-select"
        style={{ width: "40%" }}
      >
        <option value="" disabled>
          Year
        </option>
        {years.map((year) => (
          <option key={year} value={year.toString()}>
            {year}
          </option>
        ))}
      </select>
    </div>
  );
};

export default MonthYearPicker;
